module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/my-profile-v/my-profile-v.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/my-profile-v/my-profile-v.component.scss
// module chunks = main